export function toYesNo(value: boolean): string {
  return value ? "yes" : "no";
}
